import ProductImagesGallery from './ProductImagesGallery';

export default ProductImagesGallery;